import LocationsModel from "@/models/locations";

export default {
  data() {
    return {
      voivodeship: {},
      county: {},
      community: {},
      city: {},
      street: {},
      customStreetName: "",
      number: {},
      customNumber: "",
      postalCode: '',

      voivodeships: [],
      counties: [],
      communities: [],
      cities: [],
      streets: [],
      numbers: [],

      customStreetEntrance: false,
      customNumberEntrance: false,
    }
  },

  methods: {
    getVoivodeships() {
      LocationsModel.getVoivodeships().then((res) => this.voivodeships = res.data);
    },
    getCounties() {
      if (this.voivodeship && this.voivodeship.id) {
        LocationsModel.getCounties(this.voivodeship.id).then((res) => this.counties = res.data);
      }
    },
    getCommunities() {
      if (this.county && this.county.id) {
        LocationsModel.getCommunities(this.county.id).then((res) => this.communities = res.data);
      }
    },
    getStreets() {
      if (this.city && this.city.id) {
        LocationsModel.getStreets(this.city.id).then((res) => this.streets = res.data);
      }
    },
    getCities() {
      if (this.community && this.community.id) {
        LocationsModel.getCities(this.community.id).then((res) => this.cities = res.data);
      }
    },
    getNumbers() {
      if (this.street && this.street.id) {
        LocationsModel.getHouses(this.street.id).then((res) => this.numbers = res.data);
      }
    }
  },

  watch: {
    voivodeship() {
      this.$refs.countyInput.reset();
      this.$refs.communityInput.reset();
      this.$refs.cityInput.reset();
      this.$refs.streetInput.reset();
      this.customStreetName = "";
      this.customNumber = "";
      this.$refs.numberInput.reset();
      this.postalCode = "";
      this.getCounties();
    },
    county() {
      this.$refs.communityInput.reset();
      this.$refs.cityInput.reset();
      this.$refs.streetInput.reset();
      this.customStreetName = "";
      this.customNumber = "";
      this.$refs.numberInput.reset();
      this.postalCode = "";
      this.getCommunities();
    },
    community() {
      this.$refs.cityInput.reset();
      this.$refs.streetInput.reset();
      this.customStreetName = "";
      this.postalCode = "";
      this.customNumber = "";
      this.$refs.numberInput.reset();
      this.getCities();
    },
    city() {
      this.$refs.streetInput.reset();
      this.customStreetName = "";
      this.postalCode = "";
      this.customNumber = "";
      this.$refs.numberInput.reset();
      this.getStreets();
    },
    street() {
      this.$refs.numberInput.reset();
      this.getNumbers();
    },
  },

  async mounted() {
    await this.getVoivodeships();

    /*
    If there is buildingToEdit in VueX store - load all data and set values
    Form will updating building instead of creating one.
     */
    if (this.buildingToEdit) {
      const res = await LocationsModel.getBuildingData(this.buildingToEdit.id)
      const data = res.data;
      this.voivodeship = data.voivodeship;
      await this.getCounties();
      this.county = data.county;
      await this.getCommunities();
      this.community = data.community;
      await this.getCities();
      this.city = data.city;
      await this.getStreets();
      this.postalCode = data.postal_code;

      if (data.custom_street_name) {
        this.customStreetEntrance = true;
        this.customStreetName = data.custom_street_name;
      }
      if (data.street && data.street.id) {
        this.custom_street_name = "";
        this.street = data.street;
      }
      if (data.custom_number) {
        this.customNumberEntrance = true;
        this.customNumber = data.custom_number;
      }
      if (data.number && data.number.id) {
        await this.getNumbers();
        this.customNumber = "";
        this.number = data.number;
      }
    } else if (this.cachedBuildingData) {
      const data = this.cachedBuildingData;
      this.voivodeship = data.voivodeship;
      await this.getCounties();
      this.county = data.county;
      await this.getCommunities();
      this.community = data.community;
      await this.getCities();
      this.city = data.city;
      await this.getStreets();
      this.postalCode = data.postalCode;

      if (data.customStreetName) {
        this.customStreetEntrance = true;
        this.customStreetName = data.customStreetName;
      } else if (data.street && data.street.id) {
        this.customStreetName = "";
        this.street = data.street;
      }
    }
  },
}
